import React from 'react';
import classNames from 'classnames';

const ActionTable = (props) => {
  const tableWrapper = classNames({
    'table-wrapper-inner': true,
    wide: true,
    'table-wrapper-inner--border-top': props.Heading,
  });

  const dataPrintSidebarTitle = props?.StepOne?.Heading
    ? `${props?.StepOne?.Heading} (Tabell)`
    : 'Tabell';

  return (
    <div
      className="c-action-table table-wrapper"
      data-print-sidebar-title={dataPrintSidebarTitle}
      data-is-member-of-chapter-container={
        props.isMemberOfChapterContainer || 'false'
      }
    >
      <div className={tableWrapper}>
        <div className="c-action-table__table">
          {props.Heading != null && (
            <p className="c-action-table__caption">{props.Heading}</p>
          )}
          <div className="c-action-table__large-headings">
            <p>{props.StepOne.Heading}</p>
            <p>{props.StepTwo.Heading}</p>
          </div>
          <div className="c-action-table__column-wrapper">
            <div className="c-action-table__column">
              <p className="c-action-table__column__heading">
                {props.StepOne.Heading}
              </p>
              <div
                className="c-action-table__column__content c-action-table__column__content--first"
                dangerouslySetInnerHTML={{ __html: props.StepOne.Content }}
              ></div>
            </div>

            <div className="c-action-table__secondary-wrapper">
              <div className="c-action-table__column">
                <p className="c-action-table__column__heading">
                  {props.StepTwo.Heading}
                </p>
                <div
                  className="c-action-table__column__content c-action-table__column__content--second"
                  dangerouslySetInnerHTML={{ __html: props.StepTwo.Content }}
                ></div>
              </div>
              <div className="c-action-table__column">
                <p className="c-action-table__column__heading">
                  {props.StepTwo.Heading}
                </p>
                <div
                  className="c-action-table__column__content c-action-table__column__content--third"
                  dangerouslySetInnerHTML={{ __html: props.StepThree.Content }}
                ></div>
              </div>
            </div>
          </div>
          {props.FootnoteSettings.DefaultFootnote && (
            <div className="c-action-table__table-footer">
              <div
                dangerouslySetInnerHTML={{
                  __html: props.FootnoteSettings.DefaultFootnote,
                }}
              ></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActionTable;
